import React from 'react';

import {
  VirtualizedList,
  IconButton,
  ArrowForwardIcon,
} from '@gogame/components';

const SelectableREList = ({ options, onChange }) => {
  return (
    <VirtualizedList
      data={options}
      secondaryAction={(_, { value: v }) => (
        <IconButton
          onClick={() => {
            onChange(v);
          }}
          edge={'end'}
          tooltip={'Move'}
          icon={<ArrowForwardIcon />}
        />
      )}
      button={false}
    />
  );
};

export default SelectableREList;
